import React, { FunctionComponent, useEffect, useState } from "react";
import { Disclosure } from "@headlessui/react";
import { ShoppingCartIcon, MenuIcon, XIcon } from "@heroicons/react/outline";
import { WindowLocation } from "@reach/router";
import { Link } from "gatsby";

import { CartModal } from "./Cart";
import { useGlobalState, useGlobalDispatch } from "../GlobalContext";
import { StaticImage } from "gatsby-plugin-image";

interface Props {
  location: WindowLocation<unknown>;
}

export const Header: FunctionComponent<Props> = ({ location }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sessionQuant, setSessionQuant] = useState(0);

  const { pathname } = location;
  const globalState = useGlobalState();
  const dispatch = useGlobalDispatch();

  useEffect(() => {
    if (typeof window !== "undefined") {
      setSessionQuant(
        JSON.parse(sessionStorage.getItem("PSYCHO_BETTY_SELECTIONS")) === null
          ? 0
          : JSON.parse(sessionStorage.getItem("PSYCHO_BETTY_SELECTIONS")).length
      );
    }
    dispatch({ type: "updateCartIcon", quantity: sessionQuant });
  }, [dispatch, globalState?.quantity, sessionQuant]);

  const activeNavLink = `text-white px-3 py-2 rounded-md text-md font-medium bg-gray-700  `;
  const inActiveNavLink = `text-white hover:bg-gray-700 hover:text-white px-3 py-3 pt-2 rounded-md text-md font-medium`;

  return (
    <>
      <CartModal
        open={isModalOpen}
        setOpen={setIsModalOpen}
        location={location}
      />
      <Disclosure as="nav" className="bg-black font-amaticSC text-3xl">
        {({ open }) => (
          <>
            <div className=" max-w-7xl mx-auto md:px-8 md:py-3 p-3 pb-6">
              <div className="flex items-center justify-between h-16 sm:h-24">
                <div className="flex items-center">
                  <div className="flex-shrink pb-4 sm:pb-6">
                    <Link
                      to="/"
                      className="flex-row flex items-center justify-items-center h-full"
                    >
                      <div className="h-12 w-auto mr-2 pl-2">
                        <StaticImage
                          src={"../../images/logo.png"}
                          alt="Logo"
                          placeholder="blurred"
                          layout="fixed"
                          width={90}
                          height={80}
                        />
                      </div>
                    </Link>
                  </div>
                  <div className="hidden sm:block sm:ml-6">
                    <div className="flex space-x-4">
                      <Link
                        to="/coffee"
                        className={
                          pathname.startsWith("/coffee")
                            ? activeNavLink
                            : inActiveNavLink
                        }
                      >
                        Coffee
                      </Link>
                      <Link
                        to="/merchandise"
                        className={
                          pathname.startsWith("/merchandise")
                            ? activeNavLink
                            : inActiveNavLink
                        }
                      >
                        Merchandise
                      </Link>
                      <Link
                        to="/about"
                        className={
                          pathname === "/about"
                            ? activeNavLink
                            : inActiveNavLink
                        }
                      >
                        About
                      </Link>
                      <Link
                        to="/contact"
                        className={
                          pathname === "/contact"
                            ? activeNavLink
                            : inActiveNavLink
                        }
                      >
                        Contact Us
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="hidden sm:ml-6 sm:block">
                  <div className="flex items-center">
                    <button
                      onKeyDown={() => () => setIsModalOpen(true)}
                      onClick={() => setIsModalOpen(true)}
                      className="bg-none hover:bg-gray-700 px-3 py-3 pt-2 rounded-md text-white hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                    >
                      <div className="flex items-center ">
                        <span className="sr-only">View shopping cart</span>
                        <span className="mr-3">Cart</span>
                        <div className="relative">
                          <ShoppingCartIcon
                            className="h-6 w-6"
                            aria-hidden="true"
                          />
                          <div className="font-inter font-light absolute bottom-5 left-5 w-8 h-8 text-lg rounded-full bg-red-500 text-white flex justify-center items-center">
                            {globalState?.quantity}
                          </div>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
                <div className="-mr-2 flex sm:hidden">
                  {/* Mobile menu button */}
                  <Disclosure.Button className="inline-flex items-center justify-center p-2 mt-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </Disclosure.Button>
                </div>
              </div>
            </div>

            <Disclosure.Panel
              className={`sm:hidden ${!isModalOpen ? "" : "hidden"}`}
            >
              <div className="px-2 pt-2 pb-3 space-y-1">
                <Link
                  to="/coffee"
                  className={`${
                    pathname.startsWith("/coffee") ? "bg-gray-700" : "bg-black"
                  } text-white hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-3xl font-medium`}
                >
                  Coffee
                </Link>
                <Link
                  to="/merchandise"
                  className={`${
                    pathname.startsWith("/merchandise")
                      ? "bg-gray-700"
                      : "bg-black"
                  } text-white hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-3xl font-medium`}
                >
                  Merchandise
                </Link>
                <Link
                  to="/about"
                  className={`${
                    pathname === "/about" ? "bg-gray-700" : "bg-black"
                  } text-white hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-3xl font-medium`}
                >
                  About
                </Link>
                <Link
                  to="/contact"
                  className={`${
                    pathname === "/contact" ? "bg-gray-700" : "bg-black"
                  } text-white hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-3xl font-medium`}
                >
                  Contact Us{" "}
                </Link>
                <div
                  onClick={() => setIsModalOpen(true)}
                  className={`${
                    pathname === "/cart" ? "bg-gray-700 relative" : "bg-black"
                  } text-white relative hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-3xl font-medium flex justify-start items-center`}
                >
                  <div className="mr-2">Cart</div>
                  <div className="font-inter font-extralight w-8 h-8 text-xl rounded-full bg-red-500 text-white flex justify-center items-center">
                    {globalState?.quantity}
                  </div>
                </div>
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </>
  );
};
